import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import filter from './filter'
import 'animate.css'
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper)
Vue.use(filter)

Vue.config.productionTip = false

import footerPages from '@/pages/components/footer.vue'
Vue.component('footerPages',footerPages)
import downloadApp from '@/pages/components/downloadApp.vue'
Vue.component('downloadApp',downloadApp)

new Vue({
  router,
  render: h => h(App)
}).$mount("#app")